import React from "react";
import ArticleConclusion from "../ArticleConclusion/ArticleConclusion";
import "./ArticleBody.css";

const ArticleBody = ({ body }) => {
  const paragraphs = String(body || "")
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);

  if (paragraphs.length === 0) {
    return null;
  }

  const main = paragraphs.slice(0, Math.max(1, paragraphs.length - 1));
  const conclusion = paragraphs.length > 1 ? paragraphs[paragraphs.length - 1] : null;

  return (
    <div className="article-body">
      {main.map((paragraph, index) => (
        <p key={`${index}-${paragraph.slice(0, 24)}`}>{paragraph}</p>
      ))}

      {conclusion ? (
        <ArticleConclusion>
          <p>{conclusion}</p>
        </ArticleConclusion>
      ) : null}
    </div>
  );
};

export default ArticleBody;
